import { createSelector } from 'reselect'

import { Team } from '@driftt/api-types'

import { rootSelector } from 'utils/redux'

export const teams = rootSelector('teams')

export const teamsOptions = createSelector(teams, (allTeams) =>
  allTeams.map((team: Team) => ({
    label: team.name,
    value: team,
  }))
)
